import React from 'react';
import { useForm } from '@mantine/form';
import {
  TextInput,
  NumberInput,
  Select,
  Button,
  Grid,
  Box,
} from '@mantine/core';

function AddUser() {
  // Initialize form with default values
  const form = useForm({
    initialValues: {
      username: '',
      phone: '',
      gender: '',
      age: 0,
    },

    // Optional: add validation rules
    validate: {
      username: (value) => (value.trim().length === 0 ? 'Username is required' : null),
      phone: (value) => (value.trim().length === 0 ? 'Phone number is required' : null),
      gender: (value) => (!value ? 'Please select a gender' : null),
      age: (value) => (value <= 0 ? 'Age must be a positive number' : null),
    },
  });

  // Handle form submission
  const handleSubmit = (values) => {
    // Replace this with your API call or other logic
    console.log('Form submitted:', values);
  };

  return (
    // <Box maw={600} mx="auto"> keep center Form
    <Box  >
      <h2>Add User</h2>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid>
          <Grid.Col sm={6}>
            <TextInput
              label="Username"
              placeholder="Enter username"
              {...form.getInputProps('username')}
            />
          </Grid.Col>

          <Grid.Col sm={6}>
            <TextInput
              label="Phone"
              placeholder="Enter phone number"
              {...form.getInputProps('phone')}
            />
          </Grid.Col>

          <Grid.Col sm={6}>
            <Select
              label="Gender"
              placeholder="Select gender"
              data={[
                { value: 'male', label: 'Male' },
                { value: 'female', label: 'Female' },
                { value: 'other', label: 'Other' },
              ]}
              {...form.getInputProps('gender')}
            />
          </Grid.Col>

          <Grid.Col sm={6}>
            <NumberInput
              label="Age"
              placeholder="Enter age"
              min={0}
              {...form.getInputProps('age')}
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <Button type="submit">Submit</Button>
          </Grid.Col>
        </Grid>
      </form>
    </Box>
  );
}

export default AddUser;
